export const PaymentMethodDisplayWrapper = 'flex w-full items-start'

export const PaymentMethodDisplayIconWrapper = 'w-[64] pr-2'

export const PaymentMethodDisplayContentWrapper =
  'font-Roboto text-14 leading-20 flex flex-col justify-start text-black'

export const PaymentMethodDisplayNameWrapper = 'font-Roboto'

export const PaymentMethodDisplayExpiredWrapper = 'text-errorRed'

export const PaymentMethodDisplayNoteWrapper = 'text-grayRegular text-12 pt-1'

export const PaymentMethodDisplayStandardWrapper = ''

export const PaymentMethodDisplayAddressTitle = 'underline'

export const PaymentMethodDisplayAddressDisplay = 'text-14 leading-18'
